import React from 'react';
import { Button, Icon } from 'framework7-react';
import II18 from '../../translate/II18';
import PropTypes from 'prop-types';

class DeleteButton extends React.Component {
  render = () => {
    const { onDeleteClick, outline, animateTitle } = this.props;

    return (
      <div style={{ width: 150, display: 'flex', justifyContent: 'right' }}>
        <Button
          id={'galleryDeleteSelected'}
          fill={!outline}
          outline={outline}
          onClick={onDeleteClick}
          className={
            'scan-portal ' + (animateTitle ? 'animateWidth captionOnHover' : '')
          }
          style={{
            textOverflow: 'unset',
            paddingRight: animateTitle ? 32 : 10
          }}
        >
          <Icon material="delete_forever" />
          {animateTitle && (
            <span>
              <II18>title_delete</II18>
            </span>
          )}
        </Button>
      </div>
    );
  };
}

DeleteButton.propTypes = {
  animateTitle: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  outline: PropTypes.bool
};
export default DeleteButton;
